import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { errMsg } from "../api";
import GoogleAuthButton from "../components/GoogleAuthButton";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await register(form);
            navigate("/account");
        } catch (e) {
            setErr(errMsg(e));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-5 py-20" data-testid="register-page">
            <div className="card-soft p-8">
                <h1 className="font-serif text-3xl mb-1">Join the Wellness Circle</h1>
                <p className="text-[var(--muted)] text-sm mb-6">Create your account in seconds.</p>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="lbl">Full name</label>
                        <input className="field" required value={form.name} onChange={set("name")} data-testid="reg-name" />
                    </div>
                    <div>
                        <label className="lbl">Email</label>
                        <input className="field" type="email" required value={form.email} onChange={set("email")} data-testid="reg-email" />
                    </div>
                    <div>
                        <label className="lbl">Phone (optional)</label>
                        <input className="field" value={form.phone} onChange={set("phone")} data-testid="reg-phone" />
                    </div>
                    <div>
                        <label className="lbl">Password</label>
                        <input className="field" type="password" minLength={6} required value={form.password} onChange={set("password")} data-testid="reg-password" />
                    </div>
                    {err && <div className="text-sm text-[var(--terra)]" data-testid="reg-error">{err}</div>}
                    <button className="btn btn-primary w-full justify-center py-3" disabled={loading} data-testid="reg-submit">
                        {loading ? "Creating account…" : "Create account →"}
                    </button>
                </form>
                <GoogleAuthButton
                    onSuccess={() => navigate("/account")}
                    onError={(m) => setErr(m)}
                />
                <div className="text-center text-sm mt-5 text-[var(--muted)]">
                    Already have an account? <Link to="/login" className="text-[var(--ink)] underline">Sign in</Link>
                </div>
            </div>
        </div>
    );
}
